<template>
  <v-form
    ref="addThirdPartyWorksForm"
    v-model="isFormValid"
    class="third-party-works-dialog"
    lazy-validation
    @submit.prevent="submitForm"
  >
    <label class="input-label">Tytuł utworu:</label>
    <v-text-field
      v-model="title"
      v-bind="props.textField"
      height="40"
      class="third-party-works-dialog__input"
      :rules="[rules.required]"
    />

    <label class="input-label">Autor utworu:</label>
    <v-text-field
      v-model="author"
      v-bind="props.textField"
      height="40"
      class="third-party-works-dialog__input"
      :rules="[rules.required]"
    />

    <label class="input-label">Informacje o prawach:</label>
    <v-textarea
      v-model="info"
      v-bind="props.textField"
      height="false"
      no-resize
      :rules="[rules.required]"
      class="third-party-works-dialog__input third-party-works-dialog__textarea"
    />

    <v-btn
      class="custom-submit-button mt-0"
      color="primary"
      depressed
      :loading="isFormProcessing"
      type="submit"
    >
      Dodaj utwór
    </v-btn>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';

export default {
  data() {
    return {
      props,
      rules,
      isFormValid: true,
      title: null,
      author: null,
      info: null,
    };
  },

  computed: {
    ...mapState('metrics', [
      'isFormProcessing',
      ]),
  },

  methods: {
    ...mapActions('metrics', [
      'addThirdPartyWorks',
    ]),
    submitForm() {
      this.$refs.addThirdPartyWorksForm.validate();
      if (this.isFormValid) {
        const params = {
          title: this.title,
          author: this.author,
          info: this.info,
        };
        this.addThirdPartyWorks(params);
      }
    },
  },
};
</script>
